<template>
  <div>
    <div class="icon_tab" v-if="this.$route.path !== '/scanCode'"
      :class="this.$route.path == '/Home/Survey' || this.$route.path == '/Home/Exhibition' || this.$route.path == '/Home/Live' ? 'float_active1' : ''"
      :style="isShow ? '' : 'right: -100%'">

      <!-- 立即报名 -->
      <img
        v-if="clientWidth > 768 && !$store.state.islogin  && this.$route.path !== '/Register'"
        :src="Res_Url + '/common/icon_tab_02.png'" alt="" @click="handleClick2"
        v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'regis' }" />
      <!-- 立即报名移动端 -->
      <img
        v-if="clientWidth <= 768 && !$store.state.islogin && this.$route.path !== '/Register'"
        :src="Res_Url + '/common/icon_tab_02.png'" alt="" @click="handleClick2"
        v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'regis' }" />
      <!-- 咨询行业专家 -->
      <div class="consult">
        <img v-if="clientWidth > 768 && this.$route.path !== '/Register'" :src="Res_Url + '/common/icon_tab_01.png'"
          alt="" @click="handleClick3" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'survey' }" />
        <!-- 咨询行业专家 -->
        <img v-if="clientWidth <= 768 && this.$route.path !== '/Register'" :src="Res_Url + '/common/icon_tab_01.png'"
          alt="" @click="handleClick3" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'survey' }" />
        <div class="consult_box" v-show="showConsultBox" ref="consultBox">
          <div class="contact-info">
            <div class="contact-item" @click="handlephone" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'phone' }">

              <div class="contact-icon phone-icon">
                <img :src="Res_Url + '/common/icon_phone.png'" alt="">
              </div>
              <div class="contact-text">
                <div class="contact-title">电话咨询</div>
                <div class="contact-number">400-810-8899</div>
              </div>
            </div>
            <div class="contact-item" @click="handlecontact" v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'contact' }">

              <div class="contact-icon message-icon">
                <img :src="Res_Url + '/common/icon_consult.png'" alt="">
              </div>
              <div class="contact-text">
                <div class="contact-title">我要询价</div>
              </div>
            </div>
          </div>

        </div>

      </div>

      <!-- 分享 -->
      <img
        v-if="clientWidth > 768 && $store.state.islogin && this.$route.path !== '/Home/Live' && this.$route.path !== '/Register'"
        :src="Res_Url + '/common/icon_tab_04.png'" alt="" @click="handleClick4"
        v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'share' }" />
      <!-- 分享移动端 -->
      <img
        v-if="clientWidth <= 768 && $store.state.islogin && this.$route.path !== '/Home/Live' && this.$route.path !== '/Register'"
        :src="Res_Url + '/common/icon_tab_04.png'" alt="" @click="handleClick4"
        v-ga="{ event: 'trk', ec: 'sidebar', ea: 'signup', el: 'share' }" />
      <!-- 返回首页 -->
      <img class="backIndex" v-if="clientWidth > 768 && this.$route.path != '/Home/Index' && this.$route.path !== '/'"
        :src="Res_Url + '/common/tab_home.png'" alt="" @click="goIndex"
        v-ga="{ event: 'trk', ec: 'sidebar', ea: 'return', el: 'homepage' }" />
      <!-- 返回首页移动端 -->
      <img class="backIndex" v-if="clientWidth <= 768 && this.$route.path != '/Home/Index' && this.$route.path !== '/'"
        :src="Res_Url + '/common/tab_home.png'" alt="" @click="goIndex"
        v-ga="{ event: 'trk', ec: 'sidebar', ea: 'return', el: 'homepage' }" />
    </div>
    <!-- 分享海报 -->
    <SharePoster :imgSrc="posterImg" :isShow="posterShow" @closePoster="closePoster"></SharePoster>
  </div>
</template>

<script>
import { GetSharePoster, GetUserLogs, AddPoints, AddAyPoints } from "@/api";
import SharePoster from "@/components/sharePoster/index.vue";
import { Res_Url } from "@/utils/ApiToken.js";
export default {
  data() {
    return {
      Res_Url: Res_Url,
      posterImg: "",
      posterShow: false,
      isShow: true,
      showConsultBox: false
    };
  },
  components: {
    SharePoster,
  },
  mounted() {
    this.isShow = true;
    // 绑定全局点击事件
    this.$nextTick(() => {
      document.addEventListener('click', this.handleGlobalClick);
    });
  },
  beforeDestroy() {
    // 清理事件监听器
    document.removeEventListener('click', this.handleGlobalClick);
  },
  methods: {
    // 处理全局点击事件
    handleGlobalClick(event) {
      // 如果咨询框没有显示，不需要处理
      if (!this.showConsultBox) {
        return;
      }
      
      // 检查点击的元素是否在咨询框内
      const consultBox = this.$refs.consultBox;
      const consultButton = event.target.closest('.consult');
      
      if (consultBox && !consultBox.contains(event.target) && !consultButton) {
        // 点击了咨询框外部且不是咨询按钮，隐藏咨询框
        this.showConsultBox = false;
      }
    },
    
    // 咨询行业专家
    handleClick1() {
      window.location.href='https://events.schneider-electric.cn/new_edition/schneider/p2s/tozhiqu.html?utm_campaign=CN_202409_IAC-CIIF&se_sr=SEemssite&se_md=owned';
    },
    // 立即报名
    handleClick2() {
      let params = this.$route.query;
      let querys;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      querys = {
        backlink: encodeURIComponent(window.location.href),
        track: params.track ? params.track : "",
        utm_source: params.utm_source ? params.utm_source : "",
        utm_medium: params.utm_medium ? params.utm_medium : "",
        utm_campaign: params.utm_campaign ? params.utm_campaign : "",
        utm_content: params.utm_content ? params.utm_content : "",
        se_sr: params.se_sr ? params.se_sr : "",
        se_md: params.se_md ? params.se_md : "",
        se_ct: params.se_ct ? params.se_ct : "",
      };
      this.$router.push({
        name: "Register",
        query: querys,
      });

    },
    // 咨询行业专家
    handleClick3() {
      this.showConsultBox = !this.showConsultBox;
    },
    // 电话咨询
    handlephone() {
      // 宽度小于750执行
      if (this.clientWidth <= 768) {
        window.location.href = 'tel:4008108899';
      }
     
    },
    handlecontact() {
      window.location.href = 'https://go.schneider-electric.cn/zh/work/support/customer-care/contact-sales.jsp?utm_campaign=CN_202509_ALL-EMS-2025-CIIF-Online&se_sr=SEemssite&se_md=owned';
    },

    // 分享
    handleClick4() {
      this.$store.state.load = true;
      GetSharePoster({
        openId: this.userInfo.OpenId,
        mobile: this.userInfo.Phone,
        mailBox: this.userInfo.Email,
        gongBoId: 10426,
        number: 7,
      }).then((res) => {
        if (res.code === "OK") {
          this.posterImg = res.message;
          this.posterShow = true;

          GetUserLogs({
            visitName: "分享",
            visitType: 5,
            url: window.location.href,
            track: this.$route.query.track ? this.$route.query.track : 10366,
          });
        } else {
          this.$toast(res.message);
        }
        this.$store.state.load = false;
      });
    },
    closePoster() {
      this.posterShow = false;
    },
    // 返回首页
    goIndex() {
      var params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 0);
      // const obj = {

      // }
      this.$router.push({
        path: "/Home/Index",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    scrollTop() {
      return this.$store.state.scrollTop
    }
  },
  watch: {
    scrollTop(current, old) {
      if (current - old > 0 && old !== 0) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>